import React, { useRef, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import Product from "../Home/Product";
import data from "../../json/index.json";

const ProductDetails = () => {
  const swiperRef = useRef(null);
  const [activeTab, setActiveTab] = useState("Description");
  const [currentImage, setCurrentImage] = useState(0);

  const slides = [
    { id: 1, content: "Eat clean and green. Eat Organic." },
    { id: 2, content: "Eat clean and green. Eat Organic." },
    { id: 3, content: "Eat clean and green. Eat Organic." },
    { id: 4, content: "Eat clean and green. Eat Organic." },
  ];

  const images = [
    "/img/products/small-1.webp",
    "/img/products/small-2.webp",
    "/img/products/small-3.webp",
  ];

  const handleImageClick = (index) => {
    setCurrentImage(index);
  };

  useEffect(() => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideTo(currentImage);
    }
  }, [currentImage]);

  return (
    <div className="product_details">
      <div className="container product_details_main">
        <div className="product_details_nav dm-sans">
          <span>page name</span>
          <i className="bi bi-chevron-right"></i>
          <span>category name</span>
          <i className="bi bi-chevron-right"></i>
          <span>product name</span>
        </div>
        <div className="product_details_sliders">
          <div className="product_details_sliders_main overflow-hidden">
            <div className="product_details_verticle_slider">
              {images.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt={`Thumbnail ${index}`}
                  onClick={() => handleImageClick(index)}
                />
              ))}
            </div>
            <div className="product_details_horizontal_slider overflow-hidden">
              <Swiper
                ref={swiperRef}
                spaceBetween={10}
                slidesPerView={1}
                onSlideChange={(swiper) =>
                  console.log("slide change", swiper.activeIndex)
                }
              >
                {images.map((img, index) => (
                  <SwiperSlide key={index}>
                    <img
                      src={img}
                      alt={`Product ${index}`}
                      style={{ width: "100%" }}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>

          <div className="product_details_slider_ctn dm-sans">
            <span className="category_name">Headphones</span>
            <span className="product_name">Noise Cancelling Headphones</span>
            <span className="product_price">$19.99</span>
            <span className="product_description">
              Sed ligula sapien, fermentum id est eget, viverra auctor sem.
              Vivamus maximus enim vitae urna porta, ut euismod nibh lacinia.
              Pellentesque at diam sed libero tincidunt feugiat. Morbi efficitur
              augue leo. Morbi convallis augue viverra purus.
            </span>
            <div className="product_events">
              <div className="product_quantity">
                <button>+</button>
                <span>1</span>
                <button>-</button>
              </div>
              <button className="add_to_cart">add to cart</button>
              <div className="wish_expand">
                <div>
                  <i className="bi bi-heart"></i>
                </div>
                <div>
                  <i className="bi bi-arrows-angle-expand"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="product_details_bottom flex-col-center">
          <div className="product_detail_tabs dm-sans">
            <div className="product_detail_tab">
              {["Description", "Additional information"].map((item) => (
                <div
                  className={activeTab === item ? "tab_active tab" : "tab"}
                  key={item}
                  onClick={() => setActiveTab(item)}
                >
                  {item}
                </div>
              ))}
            </div>
          </div>
          <div className="product_detail_tab_cnt dm-sans">
            {activeTab === "Description" ? (
              <div className="product_desc_cnt">
                <div>
                  <img src="/img/products/small-3.webp" alt="product" />
                </div>
                <div className="product_desc_cnt_dtls">
                  <span>
                    Donec accumsan auctor iaculis. Sed suscipit arcu ligula, at
                    egestas magna molestie a. Proin ac ex maximus, ultrices
                    justo eget, sodales orci. Aliquam egestas libero ac turpis
                    pharetra, in vehicula lacus scelerisque. Vestibulum ut sem
                    laoreet, feugiat tellus at, hendrerit arcu..
                  </span>
                  <ul>
                    <li>100% Original Products</li>
                    <li> Free Delivery on order above $1199</li>
                    <li> Cash on delivery might be available</li>
                  </ul>
                  <span>
                    Donec accumsan auctor iaculis. Sed suscipit arcu ligula, at
                    egestas magna molestie a. Proin ac ex maximus, ultrices
                    justo eget, sodales orci. Aliquam egestas libero ac turpis
                    pharetra, in vehicula lacus scelerisque. Vestibulum ut sem
                    laoreet, feugiat tellus at, hendrerit arcu..
                  </span>
                </div>
              </div>
            ) : (
              <div className="product_add_info_cnt ">
                <div className="product_add_info_cnt_one">
                  <div className="product_add_info_cnt_one_l">
                    <span>Size</span>
                    <span>Brands</span>
                    <span>Color</span>
                  </div>
                  <div className="product_add_info_cnt_one_r">
                    <span>L, S, XL, XXL</span>
                    <span>Airi, Draven, Mango, Valentino, Zara</span>
                    <span>Blue, Brown, Green, Pink, Violet, White</span>
                  </div>
                </div>
                <div className="product_add_info_cnt_frequent">
                  <h3>Frequently Bought Together</h3>
                  <div className={"products-grid-4 dm-sans"}>
                    {data.products.slice(0, 4).map((item) => (
                      <Product item={item} key={item.id} />
                    ))}
                  </div>
                </div>
                <div className="product_add_info_cnt_frequent">
                  <h3>RELATED PROUDCTS</h3>
                  <div className={"products-grid-4 dm-sans"}>
                    {data.products.slice(0, 4).map((item) => (
                      <Product item={item} key={item.id} />
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetails;
